"use client";

import React, { useEffect, useRef } from "react";

import {
  buildPremadeQuestionTappedProperties,
  buildPremadeQuestionsShownProperties,
  E_ShellSuggestionPlacement,
  SHELL_HOME_SUGGESTIONS,
} from "@lattice/shared-frontend/shell";

import { PromptChipRow } from "@lattice/frontend/features/chat-v8/components/PromptChipRow";
import {
  MixpanelEvents,
  trackEvent,
} from "@lattice/frontend/lib/analytics/track";

export type T_HomeSuggestionChipsProps = {
  onPress: (promptText: string) => void;
};

/** Web mirror of mobile HomeSuggestionChips: same suggestion definitions and
 * analytics taxonomy from the shared shell module. */
export function HomeSuggestionChips({ onPress }: T_HomeSuggestionChipsProps) {
  const impressionTrackedRef = useRef(false);

  // eslint-disable-next-line no-restricted-syntax -- A visible mount is an analytics impression; the ref prevents StrictMode's effect replay from double-counting it.
  useEffect(() => {
    if (impressionTrackedRef.current) return;
    impressionTrackedRef.current = true;
    const shown = buildPremadeQuestionsShownProperties(
      {
        chatSurface: "home",
        placement: E_ShellSuggestionPlacement.HOME_CHIPS,
      },
      SHELL_HOME_SUGGESTIONS,
    );
    trackEvent(MixpanelEvents.SHELL_PREMADE_QUESTIONS_SHOWN, {
      ...shown,
      // Web analytics properties are scalar-only; keep the id list stable
      // and joined (mobile sends the raw array through its own pipeline).
      question_ids: shown.question_ids.join(","),
    });
  }, []);

  return (
    <PromptChipRow
      onPress={(text) => {
        const index = SHELL_HOME_SUGGESTIONS.findIndex(
          (suggestion) => suggestion.text === text,
        );
        const suggestion = SHELL_HOME_SUGGESTIONS[index];
        if (suggestion) {
          trackEvent(
            MixpanelEvents.SHELL_PREMADE_QUESTION_TAPPED,
            buildPremadeQuestionTappedProperties(
              {
                chatSurface: "home",
                placement: E_ShellSuggestionPlacement.HOME_CHIPS,
              },
              suggestion,
              index,
            ),
          );
        }
        onPress(text);
      }}
      prompts={SHELL_HOME_SUGGESTIONS.map((suggestion) => suggestion.text)}
    />
  );
}
